import request from '@/utils/request'

export function getOrder (id) {
  return request({
    url: '/order/info/',
    method: 'get',
    params: { id: id }
  })
}

export function getOrderList (query) {
  return request({
    url: '/order/list/',
    method: 'get',
    params: query
  })
}

export function createOrder (data) {
  return request({
    url: '/order/create/',
    method: 'post',
    data
  })
}

export function setOrderTraveler (data) {
  let id = data.id
  return request({
    url: '/order/' + id + '/set_travelers/',
    method: 'post',
    data
  })
}

export function setOrderOther (data) {
  let id = data.id
  return request({
    url: '/order/' + id + '/set_other/',
    method: 'post',
    data
  })
}

export function payOrder (id) {
  return request({
    url: '/order/' + id + '/pay/',
    method: 'post'
  })
}

export function evaluateOrder (data) {
  let id = data.id
  return request({
    url: '/order/' + id + '/evaluate/',
    method: 'post',
    data
  })
}

export function delOrder (id) {
  return request({
    url: '/order/' + id + '/delete/',
    method: 'post'
  })
}
